import { friendsWithTagsQueryOptions } from '@/hooks/search/use-search-friends';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export function globalSearchIndexLoader() {
  return {
    promises: queryClient.prefetchQuery(friendsWithTagsQueryOptions).catch(catchFetcherError),
  };
}
